module.exports = __webpack_public_path__ + "static/media/bg-icon-mission.cd08e7ad.png";